import numeral from "numeral";

export function getFriendlyCount(value?: number) {
  if (value === undefined) {
    return "0";
  }
  return numeral(value).format("0.[0]a");
}
